export interface Product {
  id: string;
  name: string;
  units: number;
  priceP1: number;
  priceP2: number;
}

export interface SupplierTariff {
  id: string;
  productName: string;
  tariff: number;
  invoiceDiscount: number;
  rappel: number;
  rappelDiscount: number;
}

export interface Parameters {
  p1FixedContribution: number;
  p2EurPerLitre: number;
  p2LitresSold: number;
  furnitureCost: number;
  includeFurniture: boolean;
  vatRate: number;
  p1RappelAmount: number;
  p2RappelAmount: number;
}

export const INITIAL_PRODUCTS: Product[] = [
  {
    id: 'p1',
    name: 'Barril Estrella 50L',
    units: 422,
    priceP1: 70.243,
    priceP2: 80.4
  },
  {
    id: 'p2',
    name: 'Barril Tinto Verano 30L',
    units: 144,
    priceP1: 56.57,
    priceP2: 57.8
  },
  {
    id: 'p3',
    name: 'Barril 0.0 20L',
    units: 134,
    priceP1: 46.26,
    priceP2: 37.8
  },
  {
    id: 'p4',
    name: 'Tercio Victoria/Levante/Damm',
    units: 799,
    priceP1: 15.37,
    priceP2: 15.41
  },
  {
    id: 'p5',
    name: 'Tercio 0.0/Tostada/Radler',
    units: 87,
    priceP1: 18.115,
    priceP2: 18.8
  }
];

export const INITIAL_P1_TARIFFS: SupplierTariff[] = [
  {
    id: 'p1-1',
    productName: 'Barril 50L',
    tariff: 184.85,
    invoiceDiscount: 62,
    rappel: 8,
    rappelDiscount: 15
  },
  {
    id: 'p1-2',
    productName: 'Tinto Verano 30L',
    tariff: 113.14,
    invoiceDiscount: 50,
    rappel: 10,
    rappelDiscount: 15
  },
  {
    id: 'p1-3',
    productName: 'Barril SA 20L',
    tariff: 92.52,
    invoiceDiscount: 50,
    rappel: 10,
    rappelDiscount: 15
  },
  {
    id: 'p1-4',
    productName: '1/3 Con Alc',
    tariff: 30.74,
    invoiceDiscount: 50,
    rappel: 10,
    rappelDiscount: 15
  },
  {
    id: 'p1-5',
    productName: '1/3 Sin Alc',
    tariff: 36.23,
    invoiceDiscount: 50,
    rappel: 10,
    rappelDiscount: 10
  },
  {
    id: 'p1-6',
    productName: '1/3 Radler',
    tariff: 38.27,
    invoiceDiscount: 50,
    rappel: 10,
    rappelDiscount: 10
  },
  {
    id: 'p1-7',
    productName: '1/3 1925 Ret',
    tariff: 31.89,
    invoiceDiscount: 50,
    rappel: 10,
    rappelDiscount: 10
  },
  {
    id: 'p1-8',
    productName: '1/3 1925 NR',
    tariff: 41.92,
    invoiceDiscount: 50,
    rappel: 10,
    rappelDiscount: 10
  }
];

export const INITIAL_P2_TARIFFS: SupplierTariff[] = [
  {
    id: 'p2-1',
    productName: 'Barril 50L',
    tariff: 201,
    invoiceDiscount: 62,
    rappel: 8,
    rappelDiscount: 15
  },
  {
    id: 'p2-2',
    productName: 'Tinto Verano 30L',
    tariff: 115.6,
    invoiceDiscount: 50,
    rappel: 10,
    rappelDiscount: 15
  },
  {
    id: 'p2-3',
    productName: 'Barril SA 20L',
    tariff: 94.5,
    invoiceDiscount: 50,
    rappel: 10,
    rappelDiscount: 15
  },
  {
    id: 'p2-4',
    productName: '1/3 Con Alc',
    tariff: 34.25,
    invoiceDiscount: 50,
    rappel: 10,
    rappelDiscount: 15
  },
  {
    id: 'p2-5',
    productName: '1/3 Sin Alc',
    tariff: 40.4,
    invoiceDiscount: 50,
    rappel: 10,
    rappelDiscount: 10
  },
  {
    id: 'p2-6',
    productName: '1/3 Radler',
    tariff: 40.4,
    invoiceDiscount: 50,
    rappel: 10,
    rappelDiscount: 10
  }
];

export const INITIAL_PARAMETERS: Parameters = {
  p1FixedContribution: 6700,
  p2EurPerLitre: 0.25,
  p2LitresSold: 37000,
  furnitureCost: 4080,
  includeFurniture: true,
  vatRate: 21,
  p1RappelAmount: 12148.457,
  p2RappelAmount: 16594.315
};

export function formatEur(value: number): string {
  return new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);
}

export function formatPct(value: number): string {
  return value.toFixed(1) + '%';
}